module.exports = __webpack_public_path__ + "static/media/veritas-screenshot-4.67a0fb72.png";